import React, { useEffect, useState } from "react";
import { auth, db } from "./firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import "./Edit.css";

const EditProfile = () => {
    const [username, setUsername] = useState("");
    const [bio, setBio] = useState("");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            const userRef = doc(db, "users", user.uid);
            try {
                const userSnap = await getDoc(userRef);
                if (userSnap.exists()) {
                    setUsername(userSnap.data().username || "");
                    setBio(userSnap.data().bio || "");
                }
            } catch (error) {
                console.error("Error fetching Profile:", error);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [navigate]);

    const handleSave = async () => {
        try {
            const user = auth.currentUser;
            if (!user) return;

            const userRef = doc(db, "users", user.uid);
            await updateDoc(userRef, { username, bio });

            alert("Profile updated!");
            navigate("/dashboard");
        } catch (error) {
            console.error("Error updating profile", error);
            alert("Failed to updated profile");
        }
    };


    return (
        <>
            <Navbar />
            <div className="container">
                <h2 className="title">Edit Profile</h2>
                {loading ? (
                    <p>Loading Profile</p>
                ) : (
                    <form>
                        <div className="form-group">
                            <label>Username:</label>
                            <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <textarea placeholder="Bio" value={bio} onChange={(e) => setBio(e.target.value)}></textarea>
                        </div>
                        <button className="add-btn" type="button" onClick={handleSave}>Save</button>
                        <button className="submit-btn" type="button" onClick={() => navigate("/dashboard")}>Cancel</button>
                    </form>
                )}
            </div>
        </>
    );
};

export default EditProfile;









